import { SlideData, FeatureItem, FAQItem, SupportItem, RegulatoryItem, ContactItem, DownloadItem } from './types';

export const HERO_SLIDES: SlideData[] = [
  {
    id: 1,
    image: '/images/1.png',
    title: "WYNDME O1 PRO",
    subtitle: "AI Companion Robot",
    theme: 'light'
  },
  {
    id: 2,
    image: '/images/2.png',
    title: "Knows You.",
    subtitle: "Understands You.",
    theme: 'light'
  },
  {
    id: 3,
    image: '/images/3.png',
    title: "Cares for You.",
    subtitle: "Your Intelligent Companion",
    theme: 'light'
  },
];

export const PRODUCT_FEATURES: FeatureItem[] = [
  {
    icon: 'MessageCircle',
    title: 'AI Conversation',
    description: 'Engage in natural, intelligent conversations with our advanced AI system.'
  },
  {
    icon: 'Eye',
    title: 'AI Vision',
    description: 'Advanced computer vision for facial recognition and environment perception.'
  },
  {
    icon: 'Mic',
    title: 'Voice Recognition',
    description: 'Accurate voice recognition for seamless voice commands.'
  },
  {
    icon: 'Mic2',
    title: 'Voice Cloning',
    description: 'Customize your robot\'s voice with our voice cloning technology.'
  },
  {
    icon: 'Video',
    title: 'Remote Monitoring',
    description: 'Check in on your home from anywhere with remote camera access.'
  },
  {
    icon: 'BookOpen',
    title: 'Family Memory',
    description: 'Long-term memory to remember important moments and preferences.'
  },
  {
    icon: 'Sparkles',
    title: 'Personality Growth',
    description: 'Your robot grows and adapts to your personality over time.'
  },
  {
    icon: 'Smartphone',
    title: 'Mobile App Control',
    description: 'Complete control at your fingertips with our mobile application.'
  },
];

export const SUPPORT_ITEMS: SupportItem[] = [
  {
    title: 'User Manual',
    description: 'Download the latest User Manual.',
    link: '/support'
  },
  {
    title: 'Firmware Updates',
    description: 'Download the latest firmware for your device.',
    link: '/support'
  },
  {
    title: 'FAQ',
    description: 'Find answers to common questions.',
    link: '/support'
  },
  {
    title: 'Contact Support',
    description: 'Get in touch with our support team.',
    link: '/support'
  },
];

export const SUPPORT_FAQ: FAQItem[] = [
  {
    question: 'How do I connect Wi-Fi?',
    answer: 'To connect your WYNDME robot to Wi-Fi, open the WYNDME app and follow the on-screen instructions. Make sure your robot is in pairing mode and within range of your Wi-Fi router.'
  },
  {
    question: 'How do I reset the robot?',
    answer: 'To reset your robot, locate the reset button on the bottom of the device. Press and hold for 10 seconds until the LED indicator flashes. The robot will then restart with factory settings.'
  },
  {
    question: 'Battery charging',
    answer: 'Connect the included charger to the robot and a power outlet. The LED indicator will show charging status. Full charge typically takes 2-3 hours.'
  },
  {
    question: 'Wake word not responding',
    answer: 'Ensure the microphone is not muted and the robot is in a quiet environment. Try re-training the wake word in the app settings. If issues persist, check for firmware updates.'
  },
  {
    question: 'Remote Monitoring',
    answer: 'Open the WYNDME app and select the "Remote Monitoring" option. Ensure your robot is connected to the internet and has camera permissions enabled.'
  },
  {
    question: 'Voice Cloning',
    answer: 'In the app, go to Settings > Voice > Voice Cloning. Follow the guided process to record your voice samples. The cloning process may take a few minutes.'
  },
  {
    question: 'Camera Permissions',
    answer: 'Camera permissions are managed through your mobile device settings. Go to Settings > WYNDME > Camera and ensure access is enabled.'
  },
];

export const REGULATORY_INFO: RegulatoryItem[] = [
  {
    region: 'United States',
    certifications: [
      'FCC Part 15',
      'FCC ID',
      'CPSIA',
      'ASTM F963',
      'Children\'s Product Certificate (CPC)'
    ]
  },
  {
    region: 'European Union',
    certifications: [
      'CE',
      'RED Directive',
      'EN71',
      'RoHS',
      'WEEE',
      'Battery Regulation (EU)'
    ]
  },
  {
    region: 'Japan',
    certifications: ['TELEC']
  },
];

export const CERTIFICATE_LINKS = {
  fcc: '#',
  ce: '#',
  telec: '#',
  rohs: '#',
  battery: '#'
};

export const PRIVACY_TOPICS = [
  'Privacy Policy',
  'Data Collection',
  'Voice Data',
  'Camera Usage',
  'Cloud Storage',
  'Account Security',
  'Children\'s Privacy',
  'GDPR',
  'CCPA',
];

export const WARRANTY_CONTENT = {
  title: 'Limited Warranty',
  sections: [
    {
      title: 'Warranty Coverage',
      content: 'WYNDME warrants that the product will be free from defects in materials and workmanship for a period of one (1) year from the date of purchase.'
    },
    {
      title: 'Warranty Period',
      content: 'The warranty period begins on the date of original purchase and extends for one (1) year.'
    },
    {
      title: 'Warranty Exclusions',
      content: 'This warranty does not cover damage caused by accident, misuse, abuse, neglect, improper installation, unauthorized repairs, or normal wear and tear.'
    },
    {
      title: 'How to Request Service',
      content: 'To request warranty service, please contact our support team at support@wyndme.cn with your purchase information and a description of the issue.'
    },
  ]
};

export const CONTACT_ITEMS: ContactItem[] = [
  {
    category: 'Customer Support',
    email: 'support@wyndme.cn'
  },
  {
    category: 'Sales',
    email: 'sales@wyndme.cn'
  },
];

export const DOWNLOAD_ITEMS: DownloadItem[] = [
  {
    title: 'WYNDME App',
    platform: 'iOS',
    version: 'v2.0.1',
    link: '#'
  },
  {
    title: 'WYNDME App',
    platform: 'Android',
    version: 'v2.0.1',
    link: '#'
  },
  {
    title: 'WYNDME App',
    platform: 'APK',
    version: 'v2.0.1',
    link: '#'
  },
  {
    title: 'Firmware',
    platform: 'O1 Pro',
    version: 'v1.5.0',
    link: '#'
  },
  {
    title: 'User Manual',
    platform: 'PDF',
    version: 'v1.2',
    link: '#'
  },
  {
    title: 'Release Notes',
    platform: 'PDF',
    version: 'v1.5.0',
    link: '#'
  },
  {
    title: 'Compliance Documents',
    platform: 'PDF',
    version: '',
    link: '#'
  },
];

export const FAQ_CATEGORIES = [
  {
    category: 'Wi-Fi',
    questions: [
      'How do I connect to Wi-Fi?',
      'Why won\'t my robot connect to Wi-Fi?',
      'Can I change Wi-Fi networks?',
      'What Wi-Fi bands are supported?'
    ]
  },
  {
    category: 'Bluetooth',
    questions: [
      'How do I pair my robot via Bluetooth?',
      'Bluetooth connection issues',
      'Can I connect multiple devices?'
    ]
  },
  {
    category: 'Charging',
    questions: [
      'How long does charging take?',
      'How do I know when charging is complete?',
      'Can I use third-party chargers?'
    ]
  },
  {
    category: 'Battery',
    questions: [
      'What is the battery life?',
      'How to maximize battery life?',
      'Battery replacement options'
    ]
  },
  {
    category: 'Camera',
    questions: [
      'How to enable camera permissions?',
      'Camera quality issues',
      'Can I disable the camera?'
    ]
  },
  {
    category: 'Voice',
    questions: [
      'How to set up wake word?',
      'Voice recognition not working',
      'Voice cloning setup'
    ]
  },
  {
    category: 'App',
    questions: [
      'How to download the app?',
      'App crashes or freezes',
      'How to update the app?'
    ]
  },
  {
    category: 'Firmware',
    questions: [
      'How to update firmware?',
      'Firmware update failed',
      'Latest firmware version'
    ]
  },
  {
    category: 'Warranty',
    questions: [
      'What is covered under warranty?',
      'How to file a warranty claim?',
      'Warranty period'
    ]
  },
];

export const COMPANY_NAME_EN = "WYNDME";
export const COMPANY_NAME_CN = "奎牛智能科技（广州）有限公司";
export const CONTACT_EMAIL = "wyndme@qq.com";
export const BASE_URL = "www.wyndme.cn";
